export const SHORTCUT_GROUPS: {title: string; items: [string, string][]}[] = [
  {
    title: 'Move navigation',
    items: [
      ['← / →', 'Previous / next move on the current line'],
      ['Shift + →', 'Enter a variation'],
      ['Shift + ←', 'Exit back to the mainline'],
      ['↑ / Home', 'Jump to the starting position'],
      ['↓ / End', 'Jump to the end of the current line'],
    ],
  },
  {
    title: 'Study',
    items: [
      ['Space', 'Play / pause autoplay (advances chapters at a lesson’s end)'],
      ['f', 'Flip board'],
      ['n', 'Next chapter'],
      ['g', 'Open glyph / annotation tool'],
      ['x', 'Show / hide the opponent threat (engine on)'],
      ['?', 'Toggle this shortcuts panel'],
    ],
  },
];

// General usage guide - the non-keyboard half of the "?" help modal.
// Answers "where do I find X" and "how long do I have to undo Y", so it
// doesn't have to live scattered across inline hints (the old
// "Right-click on move for options" chip next to the move search box, for
// instance - that's folded in here instead now).
export const INFO_GROUPS: {title: string; items: string[]}[] = [
  {
    title: 'Board & interaction',
    items: [
      'Right-click + drag on the board to draw an arrow. Right-click a square to circle it.',
      'Right-click a move in the move list to promote to mainline, annotate, or delete.',
      'Deleting or promoting a move shows a 60-second "Undo" banner before becoming final.',
      'Caissa Chat: The chatbot icon in the header automatically reads your current board position.',
    ],
  },
  {
    title: 'Collaboration',
    items: [
      'Presence bar: Shows who is currently active in the study, including their active chapter and move.',
      'Live shapes: Arrows and circles drawn on the board by owners or contributors are shown live to everyone.',
    ],
  },
  {
    title: 'AI & analysis',
    items: [
      'Explain Position: AI analyzes the active pawn structure, open lines, and themes. Save findings to annotations.',
      'Auto-Annotate: Owners can run engine analysis on the mainline to auto-flag blunders, mistakes, and dubious moves.',
      'Owner tools (pencil icon): Annotations, lesson details, and participant roles live here.',
    ],
  },
  {
    title: 'Workbooks & learning',
    items: [
      'Click the workbook / chapter name at the top left to add, delete, or reorder chapters.',
      'Import PGN: Bulk import multi-game files to automatically create one chapter per game.',
      'Spaced Repetition: Wrong attempts in practice or mistakes study are queued for scheduled SM-2 review.',
    ],
  },
];
